var map = {
	"./Basic/CopyRight.tsx": 60623,
	"./Basic/InfoCard.tsx": 89228,
	"./Basic/MultiTextWidget.tsx": 90682,
	"./Basic/PromoWidget.tsx": 34205,
	"./Basic/QuickLinks.tsx": 65990,
	"./Basic/RouteTruck.tsx": 64226,
	"./Basic/Spacer.tsx": 53174,
	"./Header/GlobalSiteMessage.tsx": 75524,
	"./Header/HeaderClickable.tsx": 77260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41925;